export default __webpack_public_path__ + "static/media/delivered.83a545bc.svg";